window._ = require('lodash');
//
import * as clipboard from 'clipboard-polyfill';
import VuePluralize from 'vue-pluralize';
import Form from './utilities/Form';
import VuePikaday from "@enrian/vue-pikaday";
import Swal from 'sweetalert2/dist/sweetalert2.js';
//
var moment = require('moment');
//var Pikaday = require('Pikaday');
//

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

//

window.moment       = moment;
window.Form         = Form;
window.clipboard    = clipboard;
window.VuePluralize = VuePluralize;
window.VuePikaday   = VuePikaday;
window.Swal         = Swal;